/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import store from "./store/index"
import VueLoading from 'vuejs-loading-plugin'
import VueAWN from "vue-awesome-notifications"

require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize
 * the JavaScript scaffolding to fit your unique needs.
 */

window.Vue = require('vue');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'X-Requested-With': 'XMLHttpRequest'
};

Vue.component('link-destroy-component', require('./components/LinkDestroyComponent').default);
Vue.component('auth', require('./components/Auth').default);

//Utils
Vue.component('feedback', require('./components/alerts/Feedback').default);
Vue.component('m-image-upload', require('./components/generics/MImageUpload').default);
Vue.component('m-signature', require('./components/generics/MSignature').default);
Vue.component('m-grid', require('./components/generics/MGrid').default);
Vue.component('time-input-component', require('./components/generics/TimeInputComponent').default);

Vue.component('float-mask-component', require('./components/FloatMaskComponent').default);
Vue.component('the-mask-component', require('./components/TheMaskComponent').default);
Vue.component('select-boolean-component', require('./components/SelectBooleanComponent').default);
Vue.component('select-component', require('./components/SelectComponent').default);
Vue.component('role-form-component', require('./components/modules/roles/RoleFormComponent').default);
Vue.component('role-management', require('./components/modules/roles/RoleManagement').default);
Vue.component('role-permission-section', require('./components/modules/roles/RolePermissionSection').default);
Vue.component('checkbox-component', require('./components/CheckboxComponent').default);
Vue.component('multiple-select-component', require('./components/MultipleSelectComponent').default);
Vue.component('summernote-component', require('./components/SummernoteComponent').default);
Vue.component('rich-text-component', require('./components/RichTextComponent').default);
Vue.component('select-boolean-nullable-component', require('./components/SelectBooleanNullableComponent').default);

Vue.component('search-box-component', require('./components/generics/SearchBoxComponent').default);
Vue.component('help-component', require('./components/HelpComponent').default);
Vue.component('m-upload', require('./components/MUpload').default);
Vue.component('documents-component', require('./components/modules/word/DocumentsComponent.vue').default);

//Modules
Vue.component('word-paragraphs', require('./components/modules/word_paragraphs/WordParagraphComponent').default);
Vue.component('word-paragraph-document', require('./components/modules/word_paragraphs/WordParagraphDocuments').default);
Vue.component('options-invalidators', require('./components/OptionInvalidatorComponent').default);
Vue.component('generate-pdf', require('./components/modules/word/GeneratePdf').default);


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Loading...', // default 'Loading'
    loading: false, // default false
    //customLoader: myVueComponent, // replaces the spinner and text with your own
    //background: 'rgb(47, 64, 80)', // set custom background
    classes: ['loading-screen-inspinia', 'animated', 'fadeIn'] // array, object or string
});

let optionsVueAWN = {
    position: "top-right",
    clean: true,
    labels: {
        tip: '',
        info: '',
        success: '',
        warning: '',
        alert: '',
        async: 'Loading',
        confirm: 'Confirmation required',
    },
    icons: {
        enabled: false,
    }
    //durations: {success: 0}
};

Vue.use(VueAWN, optionsVueAWN);


export const appVue = new Vue({
    el: '#app',
    store,
    methods: {
        html(){
            alert("ddadada")
        }
    }
});
